/** @module csi/image/ImageFlipHorizontal **/
define([
	"dojo/_base/lang",
	"csi/def/Action",
	"csi/view/PluginFactory",
	"csi/view/ToolbarPluginButton",
	"csi/image/ImageEditorPluginMixin"
], function(lang,Action,PluginFactory,ToolbarPluginButton,ImageEditorPluginMixin) {

	return PluginFactory.declare("fliphorizontal", [ToolbarPluginButton, ImageEditorPluginMixin], {
		/**
		 * Set the action for flip horizontal
		 */
		constructor: function() {
			this.defAction = lang.mixin(new Action(), {
				m_id: "ImageEditorHorizontal",
				m_onAction: "flipHorizontal"
			});
			this.defAction.setMaterialIcon("flip");
			this.defAction.resolve();
		}
	});
});